if (!customElements.get("product-info")) {
    customElements.define(
        "product-info",
        class ProductInfo extends HTMLElement {
            constructor() {
                super();
                this.input = this.querySelector(".quantity__input");
                this.currentVariant = this.querySelector(".product-variant-id");
                this.variantSelects = this.querySelector("variant-radios");
                this.submitButton = this.querySelector('[type="submit"]');
                this.stickyHeader = document.querySelector(".main-product-sticky");
                this.setupStickyHeaderHandlers();

                // setup intersection observer to fire event when scrolled past the product info
                const options = {
                    root: null, // Use the viewport as the root
                    rootMargin: "0px", // No margin added to the root bounding box
                    threshold: 0.0 // Intersection ratio threshold
                };
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (!entry.isIntersecting) {
                            // product info is out of view
                            this.stickyHeader.classList.add("is-showing");
                            this.stickyHeader.removeAttribute("inert")
                        } else {
                            // product info is back in view
                            this.stickyHeader.classList.remove("is-showing");
                            this.stickyHeader.setAttribute("inert", "")
                        }
                    });
                }, options);
                observer.observe(this);
            }

            setupStickyHeaderHandlers() {
                this.stickyHeaderGoToSize = this.stickyHeader.querySelector(".js-main-product-sticky-size");
                this.stickyHeaderAdd = this.stickyHeader.querySelector(".js-main-product-sticky-add");
                if (this.stickyHeaderGoToSize) {
                    this.stickyHeaderGoToSize.addEventListener("click", () => {
                        this.scrollIntoView({ behavior: "smooth" });
                    });
                }
                if (this.stickyHeaderAdd) {
                    this.stickyHeaderAdd.addEventListener("click", () => {
                        this.submitButton.click();
                    });
                }
            }

            cartUpdateUnsubscriber = undefined;
            variantChangeUnsubscriber = undefined;
            colorChangeUnsubscriber = undefined;
            stickyHeaderVariantChangeUnsubscriber = undefined;

            connectedCallback() {
                this.colorChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.productColorChange, (event) => {
                    this.setupStickyHeaderHandlers();
                });
                this.stickyHeaderVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                    this.setupStickyHeaderHandlers();
                });
                if (!this.input) return;
                this.quantityForm = this.querySelector(".product-form__quantity");
                if (!this.quantityForm) return;
                this.setQuantityBoundries();
                if (!this.dataset.originalSection) {
                    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
                }
                this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
                    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
                    if (event.data.sectionId !== sectionId) return;
                    this.updateQuantityRules(event.data.sectionId, event.data.html);
                    this.setQuantityBoundries();
                });
            }

            disconnectedCallback() {
                if (this.cartUpdateUnsubscriber) {
                    this.cartUpdateUnsubscriber();
                }
                if (this.variantChangeUnsubscriber) {
                    this.variantChangeUnsubscriber();
                }
                if (this.colorChangeUnsubscriber) {
                    this.colorChangeUnsubscriber();
                }
                if (this.stickyHeaderVariantChangeUnsubscriber) {
                    this.stickyHeaderVariantChangeUnsubscriber();
                }
            }

            setQuantityBoundries() {
                const data = {
                    cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
                    min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
                    max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
                    step: this.input.step ? parseInt(this.input.step) : 1
                };

                let min = data.min;
                const max = data.max === null ? data.max : data.max - data.cartQuantity;
                if (max !== null) min = Math.min(min, max);
                if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

                this.input.min = min;
                this.input.max = max;
                this.input.value = min;
                publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
            }

            fetchQuantityRules() {
                if (!this.currentVariant || !this.currentVariant.value) return;
                this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
                fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
                    .then((response) => {
                        return response.text();
                    })
                    .then((responseText) => {
                        const html = new DOMParser().parseFromString(responseText, "text/html");
                        this.updateQuantityRules(this.dataset.section, html);
                        this.setQuantityBoundries();
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
                    });
            }

            updateQuantityRules(sectionId, html) {
                const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
                const selectors = [".quantity__input", ".quantity__rules", ".quantity__label"];
                for (let selector of selectors) {
                    const current = this.quantityForm.querySelector(selector);
                    const updated = quantityFormUpdated.querySelector(selector);
                    if (!current || !updated) continue;
                    if (selector === ".quantity__input") {
                        const attributes = ["data-cart-quantity", "data-min", "data-max", "step"];
                        for (let attribute of attributes) {
                            const valueUpdated = updated.getAttribute(attribute);
                            if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
                        }
                    } else {
                        current.innerHTML = updated.innerHTML;
                    }
                }
            }
        }
    );
}
